import { lazyImportSvg } from '@/shared/utils/lazy/lazy-import-svg';

export const SignInIcons = {
  Product: lazyImportSvg(() => import('@/assets/icons/sign-in/product.svg')),
  AllInOne: lazyImportSvg(() => import('@/assets/icons/sign-in/all-in-one.svg')),
  Reward: lazyImportSvg(() => import('@/assets/icons/sign-in/reward.svg')),
  LogoBackground: lazyImportSvg(() => import('@/assets/icons/sign-in/logo-background.svg')),
};
